import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    TDeleteDocumentUploadTemplateArgs,
    deleteDocumentUploadTemplateConfiguration,
    TFetchDocumentUploadTemplateArgs,
    fetchDocumentUploadTemplateData,
    fetchSettingTemplateTransferTargetColumns,
    patchDocumentUploadTemplate,
    postDocumentUploadTemplateConfiguration,
} from './document-upload-template-slice-api';
import {DOCUMENT_UPLOAD_TEMPLATE_SLICE} from './document-upload-template-slice-constants';
import {
    TDocumentUploadTemplateConfiguratorConverted,
    IDocumentUploadTemplateData, IDocumentUploadTemplateTypeLookupData,
} from './document-upload-template-slice-type';

export const loadDocumentUploadTemplateData = createAsyncThunk<
    IDocumentUploadTemplateData, TFetchDocumentUploadTemplateArgs
>(
    `${DOCUMENT_UPLOAD_TEMPLATE_SLICE}/loadDocumentUploadTemplateData`,
    async (args, {rejectWithValue}) => {
        try {
            const response = await fetchDocumentUploadTemplateData(args);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const createDocumentUploadTemplateConfiguration = createAsyncThunk<
    TDocumentUploadTemplateConfiguratorConverted, {
    entityName: string;
    data: TDocumentUploadTemplateConfiguratorConverted;
}>(
    `${DOCUMENT_UPLOAD_TEMPLATE_SLICE}/createTableDocumentUploadTemplateConfiguration`,
    async ({data, entityName: url}, {rejectWithValue}) => {
        try {
            await postDocumentUploadTemplateConfiguration({data, url});
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const updateDocumentUploadTemplateConfiguration = createAsyncThunk<
    Partial<IDocumentUploadTemplateData>, {
    entityName: string;
    templateCode: string;
    data: Partial<IDocumentUploadTemplateData>;
}>(
    `${DOCUMENT_UPLOAD_TEMPLATE_SLICE}/updateDocumentUploadTemplateConfiguration`,
    async ({templateCode, data, entityName}, {rejectWithValue}) => {
        try {
            await patchDocumentUploadTemplate({
                entityName,
                templateCode,
                data,
            });
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
export const loadSettingTemplateTargetColumns = createAsyncThunk<
    IDocumentUploadTemplateTypeLookupData[], {
    sublistCode: string;
    sublistId?: number;
}>(
    `${DOCUMENT_UPLOAD_TEMPLATE_SLICE}/loadSettingTemplateTargetColumns`,
    async ({sublistCode, sublistId}, {rejectWithValue}) => {
        try {
            const response = await fetchSettingTemplateTransferTargetColumns({
                sublistCode, sublistId,
            });
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
export const removeDocumentUploadTemplateConfiguration = createAsyncThunk<
    string, TDeleteDocumentUploadTemplateArgs>(
        `${DOCUMENT_UPLOAD_TEMPLATE_SLICE}/removeDocumentUploadTemplateConfiguration`,
        async (args, {rejectWithValue}) => {
            try {
                const {data} = await deleteDocumentUploadTemplateConfiguration(args);
                return data;
            } catch (e) {
                return rejectWithValue(e);
            }
        },
    );
